/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import * as _ from 'lodash';

import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

import { AppUtilityService } from './../../../core/services/app-utility.service';
import { ConfigService } from './../../../core/services/config.service';
import { LocoDetail } from './../../../core/model/loco-detail.model';
import { PopupService } from './../../../core/services/popup.service';

/**
 * @export
 * @class LocoStatusContainerHeaderComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-loco-status-container-header',
  templateUrl: './loco-status-container-header.component.html',
  styleUrls: ['./loco-status-container-header.component.scss']
})

export class LocoStatusContainerHeaderComponent implements OnInit {

  @Input() locoStatusArr: Array<LocoDetail>;
  @Output() searchLocomotiveText = new EventEmitter();
  searchText: string;
  MAX_ROWS = 50;
  isSearchClick: boolean;
  configData: any;
  tabIndex: number;

  /**
   * Creates an instance of LocoStatusContainerHeaderComponent.
   * @param {AppUtilityService} appUtilityService
   * @memberOf LocoStatusContainerHeaderComponent
   */
  constructor(private appUtilityService: AppUtilityService,
    private popupService: PopupService,
    private configService: ConfigService) {
    this.configData = configService.getConfigData();
    this.tabIndex = this.configData.tabIndex.detailPage;
  }

  /**
   * Initialize the state of lifecycle hook.
   * @memberOf LocoStatusContainerHeaderComponent
   */
  ngOnInit() {
  }

  /**
   * Add new row in loco status window.
   * @memberOf LocoStatusContainerHeaderComponent
   */
  addNewLocoStatus() {
    this.isSearchClick = false;
    this.searchText = '';
    const opr = {
      operation: 'addNewLocoRowOpr'
    };
    this.popupService.setPopupOperation(opr);
    this.searchLocomotiveText.emit(this.searchText);
  }

  /**
   * Invoked when click on search icon on filter.
   * @memberOf LocoStatusContainerHeaderComponent
   */
  searchLocoStatus() {
    this.searchText = this.appUtilityService.UIformatLocomotiveId(this.searchText);
    let searchLocoText = this.searchText;
    if (searchLocoText) {
      this.isSearchClick = true;
      searchLocoText = this.appUtilityService.formatLocomotiveId(searchLocoText);
      this.searchLocomotiveText.emit(searchLocoText);
    }
  }

  /**
   * Invoked for celar loco status.
   * @memberOf LocoStatusContainerHeaderComponent
   */
  clearLocoStatus() {
    this.searchText = '';
    this.isSearchClick = false;
    this.searchLocomotiveText.emit(this.searchText);
  }

  /**
   * Invoked for set page mode.
   * @param {any} event
   * @memberOf LocoStatusContainerHeaderComponent
   */
  setPageMode(event) {
    this.popupService.setPageMode('Edit');
    this.popupService.setSubmitBtnId('searchFilterBtnId');
  }

  /**
   * Invoked for reset page mode.
   * @memberOf LocoStatusContainerHeaderComponent
   */
  resetPageMode() {
    this.popupService.setPageMode('');
    this.popupService.setSubmitBtnId('');
  }

  /**
  * Invoked when click on Backspace/Delete in search box in terminal handling.
  * @param {any} event
  * @memberOf LocoStatusContainerHeaderComponent
  */
  @HostListener('window:keydown', ['$event']) defaultDeleteBackSpaceFunctionality(event) {
    if (event.key === 'Backspace' || event.key === 'Delete') {
      const locoStatusFilterText = document.getElementById('locoStatusFilterText');
      if (locoStatusFilterText && locoStatusFilterText === document.activeElement) {
        this.clearLocoStatus();
      }
    }
  }
}
